import React from 'react';
import loadable from '@loadable/component';
import categoryIndexPageQuery from './query.graphql';
import Loader from 'src/components/loader';

const CategoryIndex = loadable(
  () => import(/* webpackChunkName: "category-index" */ './category-index'),
  {
    fallback: <Loader />,
  }
);

CategoryIndex.graphQL = categoryIndexPageQuery;

export default CategoryIndex;
